module.exports = __webpack_public_path__ + "img/menu4.574a99bb.png";